<template>
  <div
    class="container-fluid"
    style="
      user-select: none;
      background: linear-gradient(to bottom, #000000, #000000);
      height: auto;
      padding-top: 50px; 
      font-family: 'Roboto';
    "
  >
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <div class="logo mt-5 d-flex">
          <img
            class="logo-img"
            src="https://cdn.gold549.com/build/assets/img/brand/logo.png"
            style="
              width: 150px;
              height: 150px;
              margin-top: 4rem;
              margin-left: 4rem;
              border-radius: 10px;
            "
          />
        </div>
        <div class="left" style="margin: 0 0 0 5rem">
          
          <div class="card">
            <img src="https://cdn.gold549.com/build/assets/img/brand/home.png" alt="" />
          </div>
          <div class="button pt-2 d-flex justify-content-center flex-wrap">
            <a href="https://backapi.gold549.com/api/app/download/android" download="" style="margin-top: -5px;">
              <img style="height: auto; width: 150px;" src="https://cdn.gold549.com/build/assets/img/brand/android-download.png" alt="" />
            </a>
            <a href="https://backapi.gold549.com/api/app/download/ios" download="gold549.mobileconfig">
              <img style="height: auto; width: 150px;" src="https://cdn.gold549.com/build/assets/img/brand/ios-download.png" alt="" />
            </a>
            <img @click="isAndroidGuide = true" style="height: 55px; width: 150px; margin-left: -10px; margin-top: 10px;" src="https://cdn.gold549.com/build/assets/img/brand/android.png" alt=""/>
            <img @click="isIosGuide = true" style="height: 54px; width: 150px; margin-top: -2px;  margin-top: 7px;" src="https://cdn.gold549.com/build/assets/img/brand/ios.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div>
      <h3 class="text-white text-center">OUR TRUSTED PARTNERS</h3>
      <h4 class="text-muted text-center pt-2">ကျွန်ုပ်တို့၏ လက်တွဲဖော်အေးဂျင့်များတွင် ယုံကြည်စိတ်ချစွာကစားနိုင်ပါသည်။</h4>
        <div class="row justify-content-center mt-4 mx-2">
          <div class="col-4 mx-0 my-3">
            <!-- <a href="https://heylink.me/gold549/"> -->
              <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/gold549/agents/agent_1.jpg" style="width: 100%; height: 100%; background: #EEEEEE; border-radius: 10px;" alt="" />
            <!-- </a> -->
          </div>
          <div class="col-4 mx-0 my-3">
            <!-- <a href="viber://contact?number=%2B959770130747"> -->
              <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/gold549/agents/agent_2.jpg" style="width: 100%; height: 100%; background: #EEEEEE; border-radius: 10px;" alt="" />
            <!-- </a> -->
          </div>
          <div class="col-4 mx-0 my-3">
            <!-- <a href="viber://contact?number=%2B959751771069"> -->
              <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/gold549/agents/agent_3.jpg" style="width: 100%; height: 100%; background: #EEEEEE; border-radius: 10px;" alt="" />
            <!-- </a> -->
          </div>
          <div class="col-4 mx-0 my-3">
            <!-- <a href="viber://contact?number=%2B959269713231"> -->
              <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/gold549/agents/agent_4.jpg" style="width: 100%; height: 100%; background: #EEEEEE; border-radius: 10px;" alt="" />
            <!-- </a> -->
          </div>
          <div class="col-4 mx-0 my-3">
            <!-- <a href="viber://contact?number=%2B959269713231"> -->
              <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/gold549/agents/agent_5.jpg" style="width: 100%; height: 100%; background: #EEEEEE; border-radius: 10px;" alt="" />
            <!-- </a> -->
          </div>
          <div class="col-4 mx-0 my-3">
            <!-- <a href="viber://contact?number=%2B959269713231"> -->
              <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/gold549/agents/agent_6.jpg" style="width: 100%; height: 100%; background: #EEEEEE; border-radius: 10px;" alt="" />
            <!-- </a> -->
          </div>
          <div class="col-4 mx-0 my-3">
            <!-- <a href="viber://contact?number=%2B959269713231"> -->
              <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/gold549/agents/agent_7.jpg" style="width: 100%; height: 100%; background: #EEEEEE; border-radius: 10px;" alt="" />
            <!-- </a> -->
          </div>
          <div class="col-4 mx-0 my-3">
            <!-- <a href="viber://contact?number=%2B959269713231"> -->
              <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/gold549/agents/agent_8.jpg" style="width: 100%; height: 100%; background: #EEEEEE; border-radius: 10px;" alt="" />
            <!-- </a> -->
          </div>
          <div class="col-4 mx-0 my-3">
            <!-- <a href="viber://contact?number=%2B959269713231"> -->
              <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/gold549/agents/agent_9.jpg" style="width: 100%; height: 100%; background: #EEEEEE; border-radius: 10px;" alt="" />
            <!-- </a> -->
          </div>
          <div class="col-4 mx-0 my-3">
            <!-- <a href="viber://contact?number=%2B959269713231"> -->
              <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/gold549/agents/agent_10.jpg" style="width: 100%; height: 100%; background: #EEEEEE; border-radius: 10px;" alt="" />
            <!-- </a> -->
          </div>
          <div class="col-4 mx-0 my-3">
            <!-- <a href="viber://contact?number=%2B959269713231"> -->
              <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/gold549/agents/agent_11.jpg" style="width: 100%; height: 100%; background: #EEEEEE; border-radius: 10px;" alt="" />
            <!-- </a> -->
          </div>
          <div class="col-4 mx-0 my-3">
            <!-- <a href="viber://contact?number=%2B959269713231"> -->
              <img src="https://cdn.gold549.com/build/assets/img/brand/agent_2.png" style="width: 100%; height: 100%; background: #EEEEEE; border-radius: 10px;" alt="" />
            <!-- </a> -->
          </div>
        </div>  
    </div>
    <div class="row d-flex main-footer" style="margin-top: 16rem">
      <p
        class="mx-auto text-white text-sm"
        style="text-align: center; font-weight: bold"
      >
        @ GOLD549 2024 Renamed <br />
        Privacy Teams FAQ
      </p>
    </div>
        <van-overlay :show="isAndroidGuide" @click="isAndroidGuide = false">
            <div class="wrapper" @click.stop>
              <img src="https://cdn.gold549.com/build/assets/img/guide/android_guide.jpg" alt="" style="width: 100%; height: 40vh; border-radius: 5px;">
              <div class="d-flex justify-content-center mt-4">
                <button @click="isAndroidGuide = false" class="btn btn-danger mx-auto">CLOSE</button>
              </div>
            </div>
        </van-overlay>
        <van-overlay :show="isIosGuide" @click="isIosGuide = false">
            <div class="wrapper" @click.stop>
              <img src="https://cdn.gold549.com/build/assets/img/guide/ios_guide_1.jpg" alt="" style="width: 100%; height: 25vh; border-radius: 5px;">
              <img src="https://cdn.gold549.com/build/assets/img/guide/ios_guide_2.jpg" alt="" style="width: 100%; height: 25vh; border-radius: 5px;">
              <img src="https://cdn.gold549.com/build/assets/img/guide/ios_guide_3.jpg" alt="" style="width: 100%; height: 25vh; border-radius: 5px;">
              <div class="d-flex justify-content-center mt-4">
                <button @click="isIosGuide = false" class="btn btn-danger mx-auto">CLOSE</button>
              </div>
            </div>
        </van-overlay>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAndroidGuide: false,
      isIosGuide: false,
    };
  },
  methods: {
    guideShow(type) {
      if (type === 'android') {
        $('#androidModal').modal('show');
      } else {
        $('#iosModal').modal('show');
      }
    },
  },
  mounted() {},
};
</script>
<style scoped>
/* .main-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
} */
.main-footer {
    padding: 10px !important;
}
    
.text-img {
  width: 150px;
  height: 150px;
}
.phone-img {
  width: 140px;
  height: 270px;
}
h5 {
  color: #fff;
}
.p1 {
  font-size: 50px;
  color: #fff;
}
.img-cont {
  width: 30rem;
}
.heading-text {
  font-size: 32px !important;
}
.para-text {
  font-size: 18px !important;
}

@media (max-width: 786px) {
  .text-img {
    width: 130px !important;
    height: 90px !important;
  }
  .phone-img {
    width: 100px !important;
    height: 180px !important;
  }
  .img-cont {
    width: 15rem;
  }
  .main-footer {
    margin-top: 0rem !important;
    padding-top: 3.5rem !important;
    /* padding-bottom: 1rem !important; */
  }
  .right-img-container {
    padding-top: 4rem !important;
  }
  .left {
    margin-left: 0.4rem !important;
  }
  .para-text {
    font-size: 16px !important;
    font-weight: normal !important;
  }
  .btn-md {
    padding: 4px 20px;
    font-size: 14px;
    margin-top: 1rem;
    margin-left: 0.3rem;
    margin-right: 0.3rem;
  }
  .logo-img {
    margin: auto !important;
    width: 120px !important;
    height: 120px !important;
  }
  .logo {
    margin-top: 1rem !important;
  }
  .heading-text {
    font-size: 25px !important;
  }
}
</style>
